import Headroom from 'headroom.js';

const navBlock = document.querySelector(
	'.page-navigation-block-wrapper.has-sticky-nav'
);

if ( navBlock ) {
	const header = navBlock.closest( 'header' );

	if ( header ) {
		header.classList.add( 'has-sticky-nav-header' );

		// Compensate layout shift: push the next sibling element down by header height
		const nextEl = header.nextElementSibling;
		if ( nextEl ) {
			nextEl.style.marginTop = header.offsetHeight + 'px';

			new ResizeObserver( () => {
				nextEl.style.marginTop = header.offsetHeight + 'px';
			} ).observe( header );
		}

		const headroom = new Headroom( header, {
			offset: {
				up: 250,
				down: 300,
			},
			tolerance: {
				up: 5,
				down: 50,
			},
		} );

		headroom.init();
	}
}
